import React from 'react';
import Footer from '../Footer';
import { useEffect } from 'react';
import './Animation.css';



function YoutubeUrlF () {
    useEffect(() => {
        // 👇️ scroll to top on page load
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
      }, []);
    return (
        <div>
            <section>
            <div className="content holds-the-iframe">
            <iframe className='frame' src="https://script.google.com/macros/s/AKfycbw4cEPtEnuNraM01_AQ4q0lf0lEMcBqNMX-wunMsh8OBFgMVKshc-jcFta5xQcNVQr2/exec"  height="700px"></iframe>
                {/* <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/js/bootstrap.bundle.min.js" integrity="sha384-geWF76RCwLtnZ8qwWowPQNguL3RmwHVBC9FhGdlKrxdiJJigb/j/68SIy3Te4Bkz" crossorigin="anonymous"></script> */}
            </div>

            <div class='air air1'></div>
            <div class='air air2'></div>
            <div class='air air3'></div>
            <div class='air air4'></div>
            </section>

            <Footer/>    
        </div>
    );
}

export default YoutubeUrlF;
